module.exports = __webpack_public_path__ + "static/media/fail.f7cd0b84.mp3";